<template>
  <!-- スプリットボタン -->
  <!-- 非活性時にツールチップを表示するようにするためにはButton=>Button2に変更してください -->
  <div class="cx_grip_button" :draggable="draggable"  @dragstart="$emit('dragstart',$event)" @dragover="onOver($event)" @drop="onDrop($event)" @dragleave="onLeave">    
        <div class="cx_grip_button_container" :class="{cx_appevent_enabled : eventEnabled,cx_target:target}" ref="button">
            <!-- 通常のボタン-->
            <Button @click="onClick" :icon="icon" :sc="sc" :tooltip="tooltip" :disabled="disabled" :perm="perm" :buttonStyle="buttonStyle" placement="topright">
              <div class="cx_button_main">
              <SvgIcon :name="svg" v-if="svg" :width="vertical ?40 : 20" :height="vertical ?40:20"/>              
              <span>{{caption}}</span>             
              </div>
              <!-- グリップ-->
              <div class="cx_grip" :class="{disabled : disabled}" @mousedown="onMouseDown" v-if="gripDisabled == false">
                <i class="material-symbols-outlined small valign" >drag_indicator</i>
              </div>               
            </Button>

        </div>
  </div> 
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Popper from 'popper.js';

@Component
export default class GripButtion extends Vue {
  //buttonプロパティにリダイレクトする
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
  @Prop({default:null}) public buttonStyle: string;
  @Prop({default:null}) public svg: string;
  @Prop({default:false}) public target: boolean;
  @Prop({default:false}) public gripDisabled: boolean;

  public eventEnabled :boolean = false;
  public draggable: boolean = false;

  public mounted(){
    this.eventEnabled = this.$el.parentElement.classList.contains('cx_appevent_enabled');
  }
  public onClick(){
    this.$emit('click');
  }
  public onMouseDown(){
    if (this.disabled == false){
      this.draggable = true;
    }
  }
  public onOver(event:any){
    if(this.disabled == false){
      this.$emit('dragover',event);
    }
  }
  public onDrop(event:any){
    if(this.disabled == false){    
      this.$emit('drop',event);
      this.draggable = false;
    }
  }
  public onLeave(){
    if (this.disabled == false){
      this.$emit('dragleave');    
      this.draggable = false;
    }
  }
}
</script>
<style lang="scss">
.cx_grip_button{
   display:flex;      
  .cx_grip_button_container{
    display: flex;
    flex:1;
    width:100%;
    &.cx_target{
      .cx_button,.cx_dropdown{
        border-color: #838383;
        border-width: 2px;
      }
    }     
    .cx_button{
        width:100%;
        //余分なマージンを取る
        margin-left: 0px !important;
        display: flex;
        justify-content: space-between;

        .cx_button_main{
            flex:1;
            display: flex;
            justify-content: start;
            min-width: 0; //span(white-space:nowrap)でflexが崩れる
        }
    }
    .cx_grip{
      width:15px;
      margin-right: -10px;

    }
  }


}
</style>